// extracted by mini-css-extract-plugin
export default {"EventTime":"Styles_EventTime__7ooKd","Text":"Styles_Text__r19r9","CalendarIcon":"Styles_CalendarIcon__d7REd"};